import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-035f8c3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "h100P",
  style: {"width":"33%","background-color":"#fbfbfd","border-radius":"20px"}
}
const _hoisted_2 = {
  class: "w100P p-20 h100P",
  style: {}
}
const _hoisted_3 = {
  class: "",
  style: {"display":"flex","flex-direction":"column","justify-content":"space-between","gap":"15px"}
}
const _hoisted_4 = {
  class: "fontBold",
  style: {"color":"#0097DC"}
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  class: ""
}
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 0,
  class: ""
}
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  class: "w100P",
  style: {"box-sizing":"border-box","background-color":"#fbfbfd","border-radius":"20px"}
}
const _hoisted_13 = {
  class: "p-10 fontMid w100P",
  style: {"display":"flex","align-items":"start"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "fontBold",
  n: "",
  style: {"color":"#0097DC"}
}, "문의유형", -1))
const _hoisted_15 = {
  class: "flexAlignCenter fontSmall",
  style: {"gap":"15px","color":"#0097DC","flex-wrap":"wrap"}
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "optionName pLeft-10" }
const _hoisted_18 = {
  class: "p-10 fontMid w100P flexAlignCenter",
  style: {}
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "fontBold",
  n: "",
  style: {"color":"#0097DC"}
}, "문의자명", -1))
const _hoisted_20 = {
  class: "p-10 fontMid w100P flexAlignCenter",
  style: {}
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "fontBold",
  n: "",
  style: {"color":"#0097DC"}
}, "연락처", -1))
const _hoisted_22 = {
  class: "p-10 fontMid w100P flexAlignCenter",
  style: {}
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "fontBold",
  n: "",
  style: {"color":"#0097DC"}
}, "이메일", -1))
const _hoisted_24 = {
  class: "p-10 w100P flexAlignCenter",
  style: {}
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "fontBold fontMid",
  style: {"color":"#0097DC"}
}, "제목", -1))
const _hoisted_26 = {
  class: "p-10 w100P",
  style: {"display":"flex","align-items":"start"}
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "fontBold fontMid",
  style: {"color":"#0097DC"}
}, "문의 제품", -1))
const _hoisted_28 = {
  class: "flexAlignCenter fontSmall",
  style: {"gap":"15px","color":"#0097DC","flex-wrap":"wrap"}
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "optionName pLeft-10" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "fontBold fontMid pBottom-10",
  style: {"color":"#0097DC","width":"100px"}
}, "문의 내용", -1))
const _hoisted_32 = {
  class: "collectInfo flexJustiCenter",
  style: {"height":"auto","align-items":"end","flex-direction":"column","padding":"15px 10px 10px"}
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "fontBold fontMid pBottom-10 w100P",
  style: {"text-align":"left","color":"#0097DC"}
}, "개인정보 수집 및 이용안내", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "개인정보 수집 및 이용에 대한 안내", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " - 수집 및 이용 항목 : 방문경로, 회사명, 부서명, 직원수, 이름, 이메일, 연락처 ", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "- 수집 및 이용 목적/기간 : 문의 접수 및 회신과 진행", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " - 수집 및 이용 기간 : 해당 사업 종료하기 전까지 이용 (단, 요청 시 삭제) ", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 그 외 문의 내용은 관계법령 및 기타 응대를 위해 개인정보를 보관할 수 있습니다. ", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "그 밖에 사항은 개인 정보 취급 방침을 준수 합니다", -1))
const _hoisted_40 = [
  _hoisted_34,
  _hoisted_35,
  _hoisted_36,
  _hoisted_37,
  _hoisted_38,
  _hoisted_39
]
const _hoisted_41 = { class: "agreementBox flexAllCenter w100P" }
const _hoisted_42 = ["checked"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "agree",
  class: "mLeft-10 fontSmall",
  style: {"font-weight":"normal"}
}, "위 개인 정보 수집 및 이용에 동의합니다.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_gInput = _resolveComponent("gInput")!
  const _component_gPopwrap = _resolveComponent("gPopwrap")!
  const _component_TPConfirmPop = _resolveComponent("TPConfirmPop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_gPopwrap, { pPopInfo: _ctx.mPopInfo }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["w100P pTop-30 pLeft-20 pRight-20 h100P", {lowPadding: _ctx.mYesMobile}]),
          style: {"height":"auto","display":"flex","justify-content":"space-between","align-items":"start"}
        }, [
          (!_ctx.mYesMobile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("ul", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mFAQ, (que, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: index,
                        class: "flexJustiCenter",
                        style: {"padding":"10px 20px 20px","background-color":"#fff","border-radius":"20px","box-shadow":"0px 0px 4px 0px #00000040","flex-direction":"column","gap":"10px"}
                      }, [
                        _createElementVNode("p", _hoisted_4, _toDisplayString(que.id), 1),
                        _createElementVNode("div", {
                          onClick: ($event: any) => (_ctx.openAnswer(index)),
                          class: "cursorP fontBold fontSmall",
                          style: {"display":"flex","align-items":"start","justify-content":"space-between","line-height":"20px"}
                        }, [
                          _createTextVNode(_toDisplayString(que.que) + " ", 1),
                          (que.showBtn === true)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                                _createElementVNode("img", {
                                  src: require(`@/assets/icons/newDesign/openBtn.png`),
                                  style: {"width":"13px"}
                                }, null, 8, _hoisted_7)
                              ]))
                            : (_openBlock(), _createElementBlock("p", _hoisted_8, [
                                _createElementVNode("img", {
                                  src: require(`@/assets/icons/newDesign/closeBtn.png`),
                                  style: {"width":"13px"}
                                }, null, 8, _hoisted_9)
                              ]))
                        ], 8, _hoisted_5),
                        (que.showBtn === false)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createElementVNode("p", {
                                innerHTML: `${que.ans}`,
                                class: "fontSmall",
                                style: {"line-height":"23px"}
                              }, null, 8, _hoisted_11)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            style: {"width":"65%"},
            class: _normalizeClass({ w100 : _ctx.mYesMobile})
          }, [
            _createElementVNode("form", _hoisted_12, [
              _createElementVNode("fieldset", {
                class: _normalizeClass(["writerNtitle", { isMobile: _ctx.mScreenWidth <= 750 }])
              }, [
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("ul", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mAskFor, (ask, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        onClick: ($event: any) => (_ctx.getAskIdx(index)),
                        key: index,
                        class: _normalizeClass(["cursorP flexAlignCenter", { w40 : _ctx.mYesMobile}])
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["selectOpt", {selectedOpt: _ctx.isAskSelected(index)}])
                        }, null, 2),
                        _createElementVNode("p", _hoisted_17, _toDisplayString(ask.name), 1)
                      ], 10, _hoisted_16))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createVNode(_component_gInput, {
                    pInputInfo: _ctx.inputInfos.userNameInput,
                    style: {"width":"200px"}
                  }, null, 8, ["pInputInfo"])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createVNode(_component_gInput, {
                    pInputInfo: _ctx.inputInfos.userNumberInput,
                    style: {"width":"200px"}
                  }, null, 8, ["pInputInfo"])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createVNode(_component_gInput, {
                    pInputInfo: _ctx.inputInfos.userEmailInput,
                    style: {"width":"200px"}
                  }, null, 8, ["pInputInfo"])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode(_component_gInput, {
                    pInputInfo: _ctx.inputInfos.titleInput
                  }, null, 8, ["pInputInfo"])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("ul", _hoisted_28, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mOptions, (option, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        onClick: ($event: any) => (_ctx.getOptionIdx(index)),
                        key: index,
                        class: _normalizeClass(["cursorP flexAlignCenter", { w40 : _ctx.mYesMobile}])
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["selectOpt", {selectedOpt: _ctx.isSelected(index)}])
                        }, null, 2),
                        _createElementVNode("p", _hoisted_30, _toDisplayString(option.name), 1)
                      ], 10, _hoisted_29))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["w100P mainContents", {flexColumn : _ctx.mYesMobile}]),
                  style: {"height":"auto","display":"flex","align-items":"start","padding":"15px 10px 10px"}
                }, [
                  _hoisted_31,
                  _createVNode(_component_gInput, {
                    pInputInfo: _ctx.inputInfos.bodyFullStrInput
                  }, null, 8, ["pInputInfo"])
                ], 2)
              ], 2),
              _createElementVNode("fieldset", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("div", {
                  class: _normalizeClass(["noticeInfo", {w100 : _ctx.mYesMobile}]),
                  style: {"font-size":"15px","width":"85%"}
                }, _hoisted_40, 2),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    id: "agree",
                    checked: _ctx.isChecked,
                    onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleChangeCheckbox && _ctx.handleChangeCheckbox(...args)))
                  }, null, 40, _hoisted_42),
                  _hoisted_43
                ])
              ])
            ])
          ], 2)
        ], 2)
      ]),
      _: 1
    }, 8, ["pPopInfo"]),
    (_ctx.showAlertPop)
      ? (_openBlock(), _createBlock(_component_TPConfirmPop, {
          key: 0,
          pAlertPopInfo: _ctx.alertPopInfo
        }, null, 8, ["pAlertPopInfo"]))
      : _createCommentVNode("", true),
    (_ctx.showSuccessPop)
      ? (_openBlock(), _createBlock(_component_TPConfirmPop, {
          key: 1,
          pAlertPopInfo: _ctx.successPopInfo
        }, null, 8, ["pAlertPopInfo"]))
      : _createCommentVNode("", true)
  ], 64))
}